import { put, call } from "redux-saga/effects";
import { languageConstants } from '../actions/constants/languageConstants';
import { LanguageService } from "../services/api/languageService";
import { exceptionHandler } from "../pages/common/functions";

const defaultAPIErrorResult = { result: "", status: status }

function* languageGetByFilter() {
	try {
		const result = yield call(LanguageService.languageGetByFilter);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: languageConstants.LanguageGetByFilterSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: languageConstants.LanguageGetByFilterFailure, payload: res.data });
		}		
	}
	catch (e) {
		yield put({ type: languageConstants.LanguageGetByFilterFailure, payload: defaultAPIErrorResult });
	}
}

function* languageGetDetail(languageCode: any) {
	try {
		const result = yield call(LanguageService.languageGetDetail, languageCode.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: languageConstants.LanguageDetailSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: languageConstants.LanguageDetailFailure, payload: res.data });
		}		
	}
	catch (e) {
		yield put({ type: languageConstants.LanguageDetailFailure, payload: defaultAPIErrorResult });
	}
}

function* languageSave(request: any) {
	try {
		const result = yield call(LanguageService.languageSave, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: languageConstants.LanguageSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: languageConstants.LanguageSaveFailure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: languageConstants.LanguageSaveFailure, payload: e });
	}
}

function* languageUpdate(input: any) {
	try {
		const result = yield call(LanguageService.languageUpdate, input.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({ type: languageConstants.LanguageUpdateSuccess,	payload: res.data });
		}
		else {
			yield put({ type: languageConstants.LanguageUpdateFailure, payload: res.data });
		}
	}
	catch (e) {
		yield put({ type: languageConstants.LanguageUpdateFailure, payload: e });
	}
}

function* languageDelete(languageCode: any) {
	try {
		const result = yield call(LanguageService.languageDelete, languageCode.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: languageConstants.LanguageDeleteSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: languageConstants.LanguageDeleteFailure, payload: res.data });
		}		
	}
	catch (e) {
		yield put({ type: languageConstants.LanguageDeleteFailure, payload: defaultAPIErrorResult });
	}
}

export const languageSaga = {
	languageGetByFilter,
	languageGetDetail,
	languageSave,
	languageUpdate,
	languageDelete
}